/**
 * SparkScreen — the main game screen (mechanic A).
 *
 * Layout (mobile-first, 360..480 wide):
 *   z=0: Vignette (radial darkening of corners — intimacy)
 *   z=1: StarNetwork (distant pulsing stars, grows with tap count)
 *   z=2+: Game content below
 *
 *   Top:    epoch badge (e.g., "эпоха I · искра")
 *   Center: Spark (pulsing gold orb) — tappable; rings ripple on tap
 *   Above:  floating phrases drift up from the tap origin
 *   Below:  awareness counter, multiplier badge, crystallize button
 *   Bottom: Whisper of the Grove ticker
 *   Overlay: Sai activation panel (full-screen modal), Golden Spark
 *
 * Visual Sprint 2 additions (see docs/12_visual_art_bible.md and
 * docs/16_random_sensory_effects.md): Vignette, StarNetwork, and the
 * random-events scheduler wired through the Spark tap handler.
 */
import { ActivationOverlay } from '../components/ActivationOverlay.js';
import { AwarenessCounter } from '../components/AwarenessCounter.js';
import { CrystallizeButton } from '../components/CrystallizeButton.js';
import { EpochBadge } from '../components/EpochBadge.js';
import { FloatingPhrasesLayer } from '../components/FloatingPhrasesLayer.js';
import { GoldenSparkOverlay } from '../components/GoldenSparkOverlay.js';
import { LessonToastStack } from '../components/LessonToastStack.js';
import { MultiplierBadge } from '../components/MultiplierBadge.js';
import { Spark } from '../components/Spark.js';
import { StarNetwork } from '../components/StarNetwork.js';
import { StreakIndicator } from '../components/StreakIndicator.js';
import { Vignette } from '../components/Vignette.js';
import { WhisperTicker } from '../components/WhisperTicker.js';
import styles from './SparkScreen.module.css';

export function SparkScreen(): JSX.Element {
  return (
    <>
      {/* Backdrop layers — fixed to the viewport so they cover the whole
          screen including the area outside the centered .root column. */}
      <Vignette />
      <StarNetwork />

      <main className={styles.root}>
        <header className={styles.header}>
          <EpochBadge />
        </header>

        <section className={styles.center}>
          <Spark />
          <FloatingPhrasesLayer />
        </section>

        <section className={styles.stats}>
          <AwarenessCounter />
          <StreakIndicator />
          <MultiplierBadge />
        </section>

        <footer className={styles.footer}>
          <CrystallizeButton />
          <WhisperTicker />
        </footer>

        <ActivationOverlay />
        <GoldenSparkOverlay />
        <LessonToastStack />
      </main>
    </>
  );
}
